module.exports = __webpack_public_path__ + "static/media/calendar.154b121a.png";